import React from 'react';
import PropTypes from 'prop-types';

import Styles from './Slider.styles';

export const SliderHandle = ({
  domain: [min, max],
  getHandleProps,
  handle: { id, percent, value },
}) => (
  <div
    aria-valuemax={max}
    aria-valuemin={min}
    aria-valuenow={value}
    className={Styles.handle}
    role="slider"
    style={{
      left: `${percent}%`,
    }}
    {...getHandleProps(id)}
  />
);

SliderHandle.propTypes = {
  disabled: PropTypes.bool,
  domain: PropTypes.arrayOf(PropTypes.number),
  getHandleProps: PropTypes.func.isRequired,
  handle: PropTypes.shape({
    id: PropTypes.string.isRequired,
    percent: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  }).isRequired,
};

SliderHandle.defaultProps = {
  disabled: false,
  domain: [],
};

export default SliderHandle;
